import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { toasterMessages } from '@messages/messages';
import * as crypto from "crypto-js";
import { ToastrService } from 'ngx-toastr';
import { LoginRegisterService } from 'src/app/login-register/login-register.service';
@Component({
  selector: 'app-confirmpassword',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.scss']
})

export class ConfirmPasswordComponent implements OnInit {

  @ViewChild('setPasswordBtn') setPasswordBtn: any;
  token: any;
  submitted: boolean = false;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private loginRegisterService: LoginRegisterService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
  ) {
    this.route.queryParams.subscribe(params => {
      this.token = params.token;
    });
  }

  confirmPwdForm = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(6)]],
    confirmPassword: ['', Validators.required]
  }, {
    validator: this.mustMatch('password', 'confirmPassword')
  });

  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  get f() { return this.confirmPwdForm.controls; }

  ngOnInit() { }

  validateConfirmPassword() {
    if (this.confirmPwdForm.get('confirmPassword')?.value?.length > this.confirmPwdForm?.get('password')?.value?.length) {
      this.setPasswordBtn.focus();
    }
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  toggleConfirmPasswordVisibility() {
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }

  confirmPwdSubmit() {
    this.submitted = true;
    if (this.confirmPwdForm.invalid) {
      return;
    }
    if (this.confirmPwdForm.value.password === this.confirmPwdForm.value.confirmPassword) {
      const obj = {
        token: this.token,
        password: crypto.AES.encrypt(this.confirmPwdForm.value.confirmPassword?.trim(), "evaltrixSecret").toString()
      };

      this.loginRegisterService.resetPassword(obj).subscribe((res) => {
        this.toastr.success('Password has been changed successfully.', '', { timeOut: 2000 });
        if (res && res.token) {
          // Valid invitation found - redirect to candidate login with token
          this.router.navigate(['/candidate'], { queryParams: { token: res.token, changePwd: 'true' } });
        } else if (res && (res.email || res.phone)) {
          // No valid invitation found - show message to check email/WhatsApp
          const contact = res.email || res.phone;
          this.toastr.info(`Please check your ${res.email ? 'email' : 'WhatsApp'} for the latest assessment invitation link.`, 'Password Reset Complete', { timeOut: 5000 });
          this.router.navigate(['/login']);
        } else {
          // Fallback - just show success and redirect to login
          this.toastr.info('Please use the invitation link sent to your email or WhatsApp to access your assessment.', 'Password Reset Complete', { timeOut: 5000 });
          this.router.navigate(['/login']);
        }
      }, (err) => {
        this.toastr.warning(err?.error?.errors[0]?.error || toasterMessages.somethingWentWrong);
      });
    } else {
      this.toastr.info(toasterMessages.candidatePasswordInfo);
    }
  }

}
